import { useEffect, useState } from "react";
import { GetSitemapJumboformsRequest } from "api/EmbedDynamicsController";

const JumboformsSiteMap = () => {
  const [parsedXml, setParsedXml] = useState("");

  const fetchUrlList = async () => {
    const response = await GetSitemapJumboformsRequest();
    if (response.status === "success") {
      // Parse the XML to extract just the urlset content
      try {
        // Create a temporary DOM parser to extract the XML content
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(response.data, "text/xml");

        // Get the serialized XML content
        const serializer = new XMLSerializer();
        const urlsetElement = xmlDoc.getElementsByTagName("urlset")[0];

        if (urlsetElement) {
          const xmlString = serializer.serializeToString(urlsetElement);
          setParsedXml(xmlString);
        }
      } catch (error) {
        console.error("Error parsing XML:", error);
        setParsedXml(response.data); // Fallback to the original string
      }
    }
  };

  useEffect(() => {
    fetchUrlList();
  }, []);

  // If there's no content yet, show loading
  if (!parsedXml) {
    return <div>Loading sitemap...</div>;
  }

  // Render the raw XML without pre tag
  return <div dangerouslySetInnerHTML={{ __html: parsedXml }} />;
};

export default JumboformsSiteMap;
